module.exports = __webpack_public_path__ + "img/challenge-halfpair.b51ca29b.png";